// @flow

export default class {
  // s: 0 ~  => 傾き
  // h: 0 ~ => 最大成長速度
  // x: 0.00 ~ 1.00 => 日光量
  static calculate(s: number, h: number, x: number): number {
    return Math.round(((s * x) / (1 + h * x)) * 100) / 100;
  }
}



// WEBPACK FOOTER //
// ./src/lib/michaelis_menten_equation/michaelis_menten_equation.js